import {inject} from 'aurelia-framework';
import {Router} from 'aurelia-router';
import {AuthService} from '../../services/authService';
import {UserMessageService} from '../../services/userMessageService';
import { ContactAPI } from '../../services/contactAPI';
import { ValidationControllerFactory, ValidationRules, validateTrigger } from 'aurelia-validation';
import $ from 'jquery';
import 'jquery-ui-dist';
@inject(AuthService, Router, ContactAPI, UserMessageService, ValidationControllerFactory)
export class Contacts {
    constructor(authService, router, api, userMessageService, controllerFactory) {

        this.authService = authService;
        this.router = router;
        this.api = api;
        this.userMessageService = userMessageService;

        this.saving = false;
        this.groups = [
            { id: 0, name: 'Group1' },
            { id: 1, name: 'Group2' },
            { id: 2, name: 'Group3' },
        ];

        this.editgroups = [
          { id: 0, name: 'Group1' },
          { id: 1, name: 'Group2' },
          { id: 2, name: 'Group3' },
      ];
        this.selectedGroup = null;
        this.selectedGroupLabel = null;
        this.groupEditMode = false;

        this.contacts_top_menue = true;
        this.upload_section = false;
        this.add_group_section = false;

        this.selectedFiles = null;
        this.label = null;
        this.onlySelectedGroup = false;

        this.add_action = true;
        this.edit_action = false;
        this.del_action = false;
        this.only_group_action = false;
        this.data = [];
        //this.isdashboard = false;
        //console.log('DASHBOARD::: ' + this.isdashboard);
        this.list_contacts = false;//show list with its contact
        this.active_list = 0;
        this.loading = false;
        this.bulk_delete = false;
        this.list_delete = false;
        this.list_save = false;
        this.total_contacts = 0;
        this.search_item = '';
        this.contacts = [];
        this.contacts_backup = [];
        this.contacts_searched = [];
        this.is_searched_item = false;
        this.is_contact_edit = false;
        this.is_contact_add_import = false;
        this.is_contact_listing = true;
        this.business_types = [
            { id: 0, value: 'Group1' },
            { id: 1, value: 'Group2' },
            { id: 2, value: 'Group3' },
            { id: 3, value: 'Group4' }
        ];
        this.selected_business_type_id = 2;
        this.selected_group_id = [];
        this.selected_group_id_dd = 0;
        this.new_group_name = '';
        this.customer_first_name;
        this.customer_last_name;
        this.customer_email;
        //selected_group_id
        //new_group_name
        //selected_business_type_id
        this.controller = controllerFactory.createForCurrentScope();
        //this.controller.validateTrigger = validateTrigger.changeOrBlur;
        //this.controller.validateTrigger = validateTrigger.manual;
        /*ValidationRules
            .ensure('customer_first_name').required().withMessage('\First Name cannot be empty')
            .ensure('customer_last_name').required().withMessage('\Last Name cannot be empty')
            .on(this);*/

      //this.controller.validateTrigger = validateTrigger.manual;
      //this.controller.validateTrigger = validateTrigger.changeOrBlur;
    this.csv_file = '';
    this.contact_id = 0; //while editing contact use this as id

    this.limitPages = [{ id: 10, name: '10' }, { id: 50, name: '50' }, { id: 100, name: '100' }];

    this.count = null;
    this.editCount = null;
    this.limit = 10;
    this.editLimit = 10;
    this.page = 1;
    this.editPage = 1;
    this.selectedlimitPages = 10;
    this.editSelectedlimitPages = 10;

    this.groupLoading=false;
    this.editGroupLoading=false;

    this.countContact = null;
    this.limitContact = 10;
    this.pageContact = 1;
    this.pagesContact = 1;
    this.selectedlimitPagesContact = 10;
    this.loadingContact=false;


  }
     attached(){
    /*$('#tag').autocomplete({
      source: this.data
    });*/
        this.autocomplete(this.data);
        /*$("#tabs").tabs({
            activate: function( event, ui ) {
                this.load_business_type();
                //console.log(this.business_types);
            }
        });*/
        this.load_business_type();
  }
  load_business_type(){
      $("#tabs").tabs();

  }

    autocomplete(data){

       $("#tag")
      // don't navigate away from the field on tab when selecting an item
      .on( "keydown", function( event ) {
        if ( event.keyCode === $.ui.keyCode.TAB &&
            $( this ).autocomplete( "instance" ).menu.active ) {
          event.preventDefault();
        }
      })
      .autocomplete({
          minLength: 0,
        /*source: this.data,*/
        source: function( request, response ) {
            response($.ui.autocomplete.filter(
                data, request.term.split(/,\s*/).pop()
                )
            );
        },
        focus: function() {
          // prevent value inserted on focus
          return false;
        },
        search: function( event, ui ) {
        console.log('Search');
        },
        select: function( event, ui ) {
          //var terms = this.split( this.value );
          var terms = this.value.split( /,\s*/ );
          // remove the current input
          terms.pop();
          // add the selected item
          terms.push( ui.item.value );
          // add placeholder to get the comma-and-space at the end
          terms.push( "" );
          this.value = terms.join( ", " );
          return false;
        }
      });
  }
  listContacts(item){
      console.log('List id ' + item.id);
      //this.selectedGroup.id = item.id;
      console.log("clicked item id: " + $(this).attr('id'));
      //$(this).addClass("intro");
      this.list_contacts = true;
      this.active_list = item.id;
       this.load_list_contacts();
  }
  allContacts(){
      this.list_contacts = false;
      this.active_list = 0;
      this.load_list_contacts();
      this.is_contact_add_import = false;
      this.is_contact_listing = true;
      this.is_contact_edit = false;
  }
  load_list_contacts(){
      this.loading = true;
      var data = {
            'group_id': this.active_list,
            'group_only': false,
            'keyword':this.search_item
        };


        this.api.getList(
            this.authService.getUser().token,
            data,
            this.pageContact,
            this.limitContact,
            this.saveLoadSuccess.bind(this),
            this.saveLoadError.bind(this));
  }
    activate(params) {
        this.loading = true;


        this.load();

    this.loadEditGroups();

    }

    load() {

        this.api.getList(
            this.authService.getUser().token,
            {},
            this.page,
            this.limit,
            this.saveLoadSuccess.bind(this),
            this.saveLoadError.bind(this));
        /*this.api.getGroupList(
            this.authService.getUser().token,
            this.saveLoadSuccessG.bind(this),
            this.saveLoadErrorG.bind(this)
        );*/
        this.is_searched_item = false;
        this.search_item = '';
        //this.get_contacts_groups();
        this.api.getBusinessTypes(
            this.authService.getUser().token,
            (data) => {
                console.log('getBusinessTypes: Success');
                console.log(data);
                this.business_types = data;
                //this.business_type_search(data);
            },
            (data) => {
                console.log('getBusinessTypes: Error');
                console.log(data);
            }
        );

    }

    get_contacts_groups(){
        this.data = [
          {id:1, label:'Japan1', value:'Japan1'},
          {id:2, label:'USA1', value:'USA1'},
          {id:3, label:'Canada1', value:'Canada1'},
          {id:4, label:'Pakistan1', value:'Pakistan1'}
        ];
    }
    is_email(email) {
        var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailReg.test(email);
    }
    add_contact(){
        /*this.controller.validate().then(result => {
            if (result.valid) {
        // validation succeeded
        console.log('Validated...');
      } else {
        // validation failed
        console.log('In Validated...');
      }

        });

        return;*/
        if(1){

            if(!this.customer_first_name || this.customer_first_name === null || this.customer_first_name.trim() === ''){
                //console.log('CSV File not found');
                this.userMessageService.setUserError("user", "First Name is empty");
                return;
            } else if(!this.customer_last_name || this.customer_last_name === null || this.customer_last_name.trim() === ''){
                this.userMessageService.setUserError("user", "Last Name is empty");
                return;
            } else if(!this.customer_email || this.customer_email === null || this.customer_email.trim() === ''){
                this.userMessageService.setUserError("user", "Email is empty");
                return;
            } else if (!this.is_email(this.customer_email)) {
                this.userMessageService.setUserError('user', 'Email is not a valid email address');
                return;
            }
          //return;
        }
        console.log(
            this.selected_business_type_id,
            this.customer_first_name,
            this.customer_last_name,
            this.customer_email,
            this.selected_group_id
        );
this.contactsaving = true;
var data = {
    'business_type_id': this.selected_business_type_id,
    'customer_first_name':  this.customer_first_name,
    'customer_last_name':  this.customer_last_name,
    'customer_email':  this.customer_email,
    'selected_group_id':  this.selected_group_id,
    'contact_id': this.contact_id
};
console.log(data);
//return;
            this.api.save(
                data,
                this.authService.getUser().token,
                this.saveLoadSuccess.bind(this),
                this.saveLoadError.bind(this));
    }
    save() {

        if(this.contacts_searched){
            console.log('Searched contacts');
            console.log(this.contacts_searched);
        } else {
            console.log('contacts');
            console.log(this.contacts_searched);
        }
        //return;
        if (this.validate())
        {
            this.search_item = '';
            this.saving = true;
            this.api.save(
                (this.is_searched_item) ? this.contacts_searched : this.contacts,
                this.authService.getUser().token,
                this.saveLoadSuccess.bind(this),
                this.saveLoadError.bind(this));

                /*this.api.getGroupList(
                  this.authService.getUser().token,
                  this.saveLoadSuccessG.bind(this),
                  this.saveLoadErrorG.bind(this)
                );*/


        }
    }
    loadGroups(){
      this.groupLoading=true;
      this.api.getGroupListWithPagination(
        this.page,
        this.limit,
        this.sortBy,
        this.sortDir,
        this.authService.getUser().token,
        this.saveLoadSuccessG.bind(this),
        this.saveLoadErrorG.bind(this)
    );
    }

    loadEditGroups(){
      this.groupEditLoading=true;
      this.api.getGroupListWithPagination(
        this.editPage,
        this.editLimit,
        this.sortBy,
        this.sortDir,
        this.authService.getUser().token,
        this.saveLoadEditSuccessG.bind(this),
        this.saveLoadErrorG.bind(this)
    );
    }
    saveLoadSuccessDelete(data) {
    this.saveLoadSuccess(data);
    this.pageContact=1;
    this.limitContact=10;
    this.selectedlimitPagesContact=10;
  }

    saveLoadSuccess(data) {
        console.log('Loaded Contacts');
        console.log(data);
        this.loading = false;
        this.contacts = data.contacts;
        this.contacts_backup = data.contacts;
        this.contacts_searched = data.contacts;

        this.countContact = data.contact_count;
        this.pagesContact =  Math.floor(this.countContact / this.limitContact);
        this.pagesContact = this.pagesContact * this.limitContact<= this.countContact ? this.pagesContact + 1 : this.pagesContact;




        //console.log("Contacts Count::: " + data.length);
        this.total_contacts = data.contact_count;
        if(this.saving){
            this.userMessageService.setUserMessage("user", "Saved!");
            this.saving = false;
        } else if(this.bulk_delete){
            this.userMessageService.setUserMessage("user", "Deleted!");
            this.bulk_delete = false;
        } else if(this.contactsaving){
             this.userMessageService.setUserMessage("user", "Contact Saved!");
            this.contactsaving = false;
             this.is_contact_add_import = false;
      this.is_contact_listing = true;
      this.is_contact_edit = false;

        }
        //Need to find a better way tthis.contactsavingo handle this request
        this.loadGroups();
    }

    saveLoadError(msg) {
        this.userMessageService.setUserError("user", msg);
        this.loading = false;

    }

    itemChanged(item) {
        item.changed = true;


    }
delBulkContacts(){
    console.log('Bulk Contacts Delete?');
    console.log(this.contacts);
    if(confirm("Are you sure you want to delete the selected contact(s)?")) {
                //this.saving = true;
                this.bulk_delete = true;
                this.api.bulkDelete(
                    this.contacts,
                    this.authService.getUser().token,
                    this.saveLoadSuccessDelete.bind(this),
                    this.saveLoadError.bind(this));
            }
}
    deleteItem(item, index) {
        if(item.new) {
            this.contacts.splice(index, 1);
        } else {
            if(confirm("Delete contact " + item.first_name + "?")) {
                this.saving = true;
                this.api.delete(
                    item,
                    this.authService.getUser().token,
                    this.saveLoadSuccess.bind(this),
                    this.saveLoadError.bind(this));
            }
        }
    }
    add_remove_contacts(item, index){

        this.contacts[index].group_id = this.active_list; //selected group id
        //this.contacts_searched[index] = item;

        var temp_search_contacts = [];
        this.contacts_searched.forEach(obj => {
            //console.log(obj.email + ' - ' + obj.id);
            //console.log(' ---------------------------- ');
            if(obj.id == item.id){
                console.log('Searched ....' +  item.id + ' - ' + item.group_id + ' - ' + item.is_group_selected);
                //obj.group_id = item.group_id;
                item.group_id = item.is_group_selected ? this.active_list : 0;
                obj = item;
            }
            temp_search_contacts.push(obj);
        });
        this.contacts_searched = temp_search_contacts;
        if(true){
            console.log(item);
            console.log(item.id);
            console.log('Searched Contacts');
            console.log(this.contacts_searched);
            console.log('All Contacts');
            console.log(this.contacts);
        }

    }

    addContact() {
        this.contacts.push({
          "first_name": "",
          "last_name": "",
          "email": "",
          "new": true
        });
    }
    addGroup(){
        //this.router.navigate("#/capture/brand/" + this.captureKey + "?method=fileupload&uploadonly=1");
        //this.router.navigate("#/user/groups");
        //this.contacts_top_menue = false;
        //this.upload_section = false;
        if(1){
        this.add_group_section = true;
        this.selectedGroupLabel = "";
        this.selectedGroup = null;

        this.is_contact_add_import = false;
        this.is_contact_listing = false;
        this.is_contact_edit = false;

        //this.add_action = true;
        //this.edit_action = false;
        //this.del_action = false;
        }
    }
    editGroup(item){
        console.log(item);
        this.add_group_section = true;
        this.groupEditMode = true;
        this.selectedGroup = item.id;
        this.selectedGroupLabel = item.label;
        console.log(this.selectedGroup + ' - ' + this.selectedGroupLabel);
        this.add_group_section = true;
         this.is_contact_add_import = false;
        this.is_contact_listing = false;
        this.is_contact_edit = false;
    }
    importContacts(){
        //this.router.navigate("#/capture/brand/" + this.captureKey + "?method=fileupload&uploadonly=1");
        this.contacts_top_menue = false;
        this.upload_section = true;
        //this.add_group_section = false;
    }
    uploadCsv(){

    }
    cancelCsv(){
        this.contacts_top_menue = true;
        this.upload_section = false;
        //this.add_group_section = false;
    }
    add_group(){
        this.list_save = true;
        this.api.saveGroup(
            {'label': this.new_group_name},
            this.authService.getUser().token,
            this.saveLoadSuccessG.bind(this),
            this.saveLoadErrorG.bind(this)
        );
    }
    saveGroup(){

        if (this.selectedGroupLabel === null || this.selectedGroupLabel.trim() === '') {
                this.userMessageService.setUserError('user', 'Group name is empty');
                return;
        }
        var data = {
            'label': this.selectedGroupLabel,
            'id': this.selectedGroup
        };
        this.add_group_section = true;
         this.is_contact_add_import = false;
        this.is_contact_listing = false;
        this.is_contact_edit = false;

        this.list_save = true;
        this.api.saveGroup(
            data,
            this.authService.getUser().token,
            this.saveLoadSuccessG.bind(this),
            this.saveLoadErrorG.bind(this)
        );
    }
    deleteGroup(item){
        //if(!this.selectedGroup.id){
            //alert('Please select a group to edit');
            //;
        //}

        var res = confirm('Are you sure you want to delet this group?');
        if(res != true){
            console.log('Delete cancelled');
            return;
        }
        var data = {
            'id': item.id,
            page:this.page,
            limit:this.limit
        };
        this.list_delete = true;
        this.api.deleteGroup(
            data,
            this.authService.getUser().token,
            this.saveLoadSuccessG.bind(this),
            this.saveLoadErrorG.bind(this)
        );
    }
    quickSendSuccess(data){
        console.log('Success');
        //console.log(data);
        var csv = '';
        for(var i = 0; i < data.contacts.length; i++) {
            var obj = data.contacts[i];
            console.log(obj.id + ' - ' + obj.email);
            csv += obj.email + ',';

        }

        csv = csv.slice(0, -1);
        console.log(csv);
        localStorage.setItem('video_email_contacts', csv);
       this.router.navigate("#/user/video/email?captureType=3");
    }
    quickSend(item){
        console.log('Quick Send ' + item.id);
        console.log(item);


         this.api.getList(
            this.authService.getUser().token,
            {'group_id': item.id, 'group_only': true},
            1,
            50,
            this.quickSendSuccess.bind(this),
            this.quickSendSuccess.bind(this)
        );

    }
    cancelGroup(){

        //this.contacts_top_menue = true;
        //this.upload_section = false;
        this.add_group_section = false;
        this.groupEditMode = false;
        if(this.selectedGroup === null || !this.selectedGroup.id){
            this.add_action = true;
            this.edit_action = false;
            this.del_action = false;;
        } else{
            this.add_action = true;
            this.edit_action = true;
            this.del_action = true;

        }
      this.is_contact_add_import = false;
      this.is_contact_listing = true;
      this.is_contact_edit = false;
      this.add_group_section = false;
    }
    onlyGroupContacts(){
        this.onlySelectedGroup = !this.onlySelectedGroup;
        this.groupChanged();
    }
    groupChanged(){
        if(!this.selectedGroup.id){
            console.log('No Group Selected ');
            this.add_action = true;
            this.edit_action = false;
            this.del_action = false;
            this.only_group_action = false;
            this.add_group_section = false;
        } else {
            console.log('Group Selected ' + this.selectedGroup.id);
            this.add_action = true;
            this.edit_action = true;
            this.del_action = true;
            this.only_group_action = true;
            this.add_group_section = false;


        }
         var data = {
            'group_id': this.selectedGroup.id,
            'group_only': this.onlySelectedGroup
        };

        this.api.getList(
            this.authService.getUser().token,
            data,
            this.page,
            this.limit,
            this.saveLoadSuccess.bind(this),
            this.saveLoadError.bind(this));
    }
    saveLoadSuccessG(data) {
        //this.loading = false;
        console.log('Group Data');
        console.log(data);
        this.groups = data.groups;
        this.count = data.count;
        this.pages =  Math.floor(this.count / this.limit);
        this.pages = this.pages * this.limit <= this.count ? this.pages + 1 : this.pages;
        if(this.list_delete){
            this.userMessageService.setUserMessage("user", "Group Deleted!");
            this.list_delete = false;
        } else if(this.list_save){
            this.userMessageService.setUserMessage("user", "Group Saved!");
            this.list_save = false;
            this.add_group_section = false;
        }
      this.is_contact_add_import = false;
      this.is_contact_listing = true;
      this.is_contact_edit = false;
      this.add_group_section = false;


      this.groupLoading=false;

        /*if(this.saving)
            this.userMessageService.setUserMessage("user", "Saved!");
        this.saving = false;*/
    }

    saveLoadEditSuccessG(data) {
      //this.loading = false;
      console.log('Group Data');
      console.log(data);
      this.editGroups = data.groups;
      this.editCount = data.count;
      this.editPages =  Math.floor(this.editCount / this.editLimit);
      this.editPages = this.editPages * this.editLimit <= this.editCount ? this.editPages + 1 : this.editPages;

      // this.is_contact_add_import = false;
      // this.is_contact_listing = true;
      // this.is_contact_edit = false;
      // this.add_group_section = false;


    this.groupEditLoading=false;

      /*if(this.saving)
          this.userMessageService.setUserMessage("user", "Saved!");
      this.saving = false;*/
  }


    prev() {
      if (this.page > 1) {
          this.page--;
          this.groups = null;
          this.loadGroups();
      }
  }

  next() {
      if (this.page < this.pages) {
          this.page++;
          this.groups = null;
          this.loadGroups();
      }
  }
  limitChange() {
      if(this.limit != this.selectedlimitPages){
      this.limit = this.selectedlimitPages;
      this.groups = null;
      this.loadGroups();
      }
    }




  prevContact() {
      if (this.pageContact > 1) {
          this.pageContact--;
          // this.loadGroups();
          this.load_list_contacts()
      }
  }

  nextContact() {
      if (this.pageContact < this.pagesContact) {
          this.pageContact++;
          this.load_list_contacts()

      }
  }



  prevEditContact() {
    if (this.editPage > 1) {
        this.editPage--;
        // this.loadGroups();
        this.loadEditGroups()
    }
}

nextEditContact() {
    if (this.editPage < this. editPages) {
        this.editPage++;
        this.loadEditGroups()

    }
}

  limitChangeContact() {
      if(this.limitContact != this.selectedlimitPagesContact){
        this.limitContact = this.selectedlimitPagesContact;
        this.pagesContact=1;
        this.load_list_contacts()

      }
    }


    saveLoadErrorG(msg) {
        this.userMessageService.setUserError("user", msg);
        //this.loading = false;

    }
    validate()
    {
        var pass = true;

        var data = this.contacts;

        for(var i = 0; i < data.length; i++) {
            //console.log(data[i].first_name  + " <-----");
            if(data[i].first_name === null || data[i].first_name.trim() == '' ) {
                this.userMessageService.setUserError('user', 'First Name is empty');
                pass = false;
            }

            if (data[i].last_name === null || data[i].last_name.trim() === '') {
                this.userMessageService.setUserError('user', 'Last name is empty');
                pass = false;
            }

            if (data[i].email === null || data[i].email.trim() === '') {
                this.userMessageService.setUserError('user', 'Email is empty');
                pass = false;
            }

            if (!this.is_email(data[i].email)) {
                this.userMessageService.setUserError('user', 'Email is not a valid email address');
                pass = false;
            }
        }

        return pass;
    }

    is_email(email) {
        var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        return emailReg.test(email);
    }
    handleKeypress(event) {
    if (event.keyCode == 13) {
      //this.search = this.searchTemp;
      this.search_data();
      //event.preventDefault();
      return false;

    }

    return true;
  }


  search_data(){
    //this.data_backup = this.data;
    this.pageContact=1;
    this.load_list_contacts();
}

     search_data_old(){
      //this.data_backup = this.data;
      this.is_searched_item = true;
      console.log(this.search_item);
      var temp_data = [];

      console.log(this.contacts_backup);
      temp_data = this.contacts_backup.filter((item, idx)=>{

          console.log(item);
          console.log(item.first_name + ' - ' + item.organization)
          var first_name = item.first_name.toLowerCase();
          var last_name = item.last_name.toLowerCase();
          var email = item.email.toLowerCase();
          var organization = (!item.organization) ? '' : item.organization.toLowerCase();
          var needle = this.search_item.toLowerCase();

         //console.log( 'INDEX OF' + first_name.indexOf(needle));
         //-1 if not found
         if(
                 first_name.indexOf(needle) > -1
                 || last_name.indexOf(needle) > -1
                 || email.indexOf(needle) > -1
                 || organization.indexOf(needle) > -1
           ){
              //console.log('Found ... ' + first_name + ' - ' + last_name + ' - ' + email + ' - ' + needle );

             return true;
         } else {
             //console.log('Not Found ... ' + first_name + ' - ' + last_name + ' - ' + email + ' - ' + needle );
            return false;
         }
          //console.log(this.search_item);
      });




      console.log(this.contacts);
      this.contacts = temp_data;
  }
  contact_edit(item, index){
      console.log('contact_edit');
      console.log(item);
      this.is_contact_edit = true;
      console.log("rdffff")
      this.is_contact_listing = false;
      this.is_contact_add_import = false;
      this.add_group_section = false;

      //console.log(item);
      //return;
    this.customer_first_name = item.first_name;
    this.customer_last_name = item.last_name;
    this.customer_email = item.email;
    this.selected_group_id = (item.group_id)? item.group_id.split(',').map(Number): [];
    this.contact_id = item.id;
    console.log('contact_id: ' + this.contact_id);
    //return;
    /*this.groups = this.groups.filter(item => {
        console.log('item id ' + item.id);
    })*/
    this.new_group_name = '';
    this.selected_business_type_id = item.business_type_id;
  }
  contact_add_import(){
      console.log('contact_add_import');
      this.is_contact_add_import = true;
      this.is_contact_listing = false;
      this.is_contact_edit = false;
      this.add_group_section = false;



      this.selected_business_type_id = 2;
      this.selected_group_id = [];
      this.selected_group_id_dd = 0;
      this.new_group_name = '';
      this.customer_first_name='';
      this.customer_last_name='';
      this.customer_email='';
      document.getElementById('logoUploadValue').value=null;
      this.csv_file = '';
      this.contact_id = 0; //while editing contact use this as id


      //this.add_action = true;
      //this.edit_action = false;
  }
  upload_csv(){
      if(1){

          //console.log("CSV File::: => ", this.csv_file[0]);
          if(!this.csv_file && this.csv_file.length <= 0){
              //console.log('CSV File not found');
              this.userMessageService.setUserError("user", "Please upload a CSV file");
              return;
          }
          //return;

        /*if (this.customer_first_name == null || this.customer_first_name.trim() == '') {
            this.userMessageService.setUserError("user", "Customer First Name is empty");
            pass = false;
        }*/

      }
      console.log('Selected Group ID', this.selected_group_id_dd)
      this.saving = true;
      this.api.upload_csv(
       this.csv_file[0],
       {'group_id':this.selected_group_id_dd},
        this.authService.getUser().token,
        this.saveLoadSuccessUpload.bind(this),
        /*(rst) => {
            console.log('Success !!!')
            console.log(rst);

            this.userMessageService.setUserError("contacts", 'Contacts uploaded successfully')
        },
        (rst) => {
            console.log('Contacts imported Error!!!');
            console.log(rst);
        }*/
        this.saveLoadError.bind(this)

      );
  }
  saveLoadSuccessUpload(data){
      if(this.saving){
          this.is_contact_add_import = false;
      this.is_contact_listing = true;
      this.is_contact_edit = false;
            this.userMessageService.setUserMessage("user", "Contact imported successfully!");
            this.saving = false;
            this.api.getList(
            this.authService.getUser().token,
            data,
            this.page,
            this.limit,
            this.saveLoadSuccess.bind(this),
            this.saveLoadError.bind(this));
     }
  }
}
